import React from 'react';
import { Provider } from 'react-redux';
import { OidcProvider, loadUser } from 'redux-oidc';

import store from './GlobalStateContainer/store';
import userManager from './Authorization/userManager';
import ProductManageReactApp from './ProductManageReactApp';

import './ProductManagementReactApp.css';

// props should contain all data we want to initialize the app with
class BridgeProductManagement extends React.Component {
    constructor(props) {
        super(props);

        // persist state in the event of a browser refresh
        store.subscribe(() => {
			//TODO: figure out why this fails when loading Bid Tracker page
			try {
				sessionStorage.setItem("ProductManagementReactApp", JSON.stringify(store.getState()))
			} catch (e) {}
		});
        
        loadUser(store, userManager);
    }

    // Make Store available to components, and instantiate ProductManageReactApp
    render() {
        return (
            <Provider store={store}>
                <OidcProvider userManager={userManager} store={store}>
                    <ProductManageReactApp {...this.props} />
                </OidcProvider>
            </Provider>
        );
    }
}

export default BridgeProductManagement;
